<template>
  <el-skeleton class="sk" animated>
    <template #template>
      <el-skeleton-item variant="p" class="sk__name" />
      <el-skeleton-item variant="image" class="sk__image" />
      <div class="sk__block">
        <el-skeleton-item variant="p" class="sk__price" />
        <el-skeleton-item variant="p" class="sk__button" />
      </div>
    </template>
  </el-skeleton>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.sk {
  width: 220px;
  border-radius: 16px;
  padding: 13px 15px;
  background: rgba(255, 255, 255, 0.61);
  box-shadow: 2px 8px 26px 0 rgba(15, 82, 100, 0.07);

  &__name {
    width: 90%;
    height: 22px;
  }

  &__image {
    width: 100%;
    height: 243px;
    border-radius: 10px;
  }

  &__block {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__price {
    width: 56px;
    height: 23px;
  }

  &__button {
    width: 110px;
    height: 38px;
  }
}

:deep(.el-skeleton__item) {
  --el-skeleton-color: #c9ccd0 !important;
  --el-skeleton-to-color: #c3c3c7 !important;
}
</style>